import type { SVGProps } from 'react';

export function PuzzleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13.91 4.727h3.636a2.727 2.727 0 0 1 2.727 2.728v3.636h.454a2.273 2.273 0 1 1 0 4.545h-.454v3.637A2.727 2.727 0 0 1 17.546 22H5.727a2.727 2.727 0 0 1-2.723-2.587L3 19.273v-2.727l.004-.094a.91.91 0 0 1 .905-.816h.455a2.273 2.273 0 0 0 0-4.545h-.455A.91.91 0 0 1 3 10.18V7.456a2.727 2.727 0 0 1 2.727-2.728h3.637v-.454a2.273 2.273 0 0 1 4.545 0z" />
    </svg>
  );
}
